import { useEffect, useState } from 'react';

export function useInView<T extends Element>(options?: IntersectionObserverInit) {
  const [element, setElement] = useState<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!element) return;
    const observer = new IntersectionObserver(([{ isIntersecting }]) => setInView(isIntersecting), options);
    observer.observe(element);
    return () => observer.disconnect();
    // `options` is only read on first run.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element]);

  return { ref: setElement, inView };
}
